import React from "react";
import { ArrowBackCircle } from "react-ionicons";
import constantURI from "../URI";
import _post from "../Functions/Post";
import SearchFilterFunction from "../Functions/SearchFilter";
import stylesASAP from "./stylesASAP";
import ASAPAuthenticate from "../Functions/ASAPAuthenticate";
import stylesMed from "../MedRep/stylesMed";
import _postBody from "../Functions/Post";
import { db, getDocs, collection, disableNetwork } from "../firebase";
import { set, get } from "idb-keyval";
import normalizeUnsyncedTransactions from "../Functions/normalizeUnsyncedTransactions";

export default class UnsyTrans extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      UST: [],
      USTCopy : [],
      SoRo: -1,
    };
  }

  async componentDidMount() {
    const { transactions } = normalizeUnsyncedTransactions();
    const UST = transactions;
    const USTCopy = transactions;
    const SoRo = JSON.parse(localStorage.getItem("OrderType"));
    localStorage.setItem("unsycJournal", JSON.stringify(0));
    await this.setState({ UST: UST, SoRo: SoRo , USTCopy : USTCopy});
  }

  onSearch = async (text) => {
    var values = await SearchFilterFunction(
      text,
      this.state.UST[0],
      this.state.USTCopy[0],
      this.state.noData
    );
    this.setState({
      UST: [values.items],
      noData: values.noData,
      
    });
  };

  onOrderClick = (item, usId) => {
    var temp = [{isDraft: this.state.isDraft, isDelivered: this.state.isDelivered, isDone: this.state.isDone}];
    localStorage.setItem('OrderId', JSON.stringify(item));
    if (usId !== undefined) {
        localStorage.setItem('USOrderId', JSON.stringify(usId));
    }
    localStorage.setItem('CurrentTab', JSON.stringify(temp));
    this.props.history.push('./SalesOrderDetail')
}

  render() {
    console.log(this.state.UST);
    return (
      <div className="container-fluid vh-100" style={stylesASAP.mainContainer}>
        <div className="pt-3 row">
          <div className="col">
            <ArrowBackCircle
              className="btn col"
              onClick={() => this.props.history.push("./Journal")}
              color={"#00bfff"}
              height="50px"
              width="50px"
            />
          </div>
        </div>
        <div className="pt-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search Here"
            onChange={(text) => this.onSearch(text)}
          />
        </div>
        <p className="pt-3 text-center h2">Unsynced Orders</p>
        

        <div>
          {this.state.UST.map((item, index) => {
            if (item !== null && item !== undefined) {
              if (this.state.SoRo === 0 && index === 0) {
                return (
                  <div key={index} className="row mt-5" >
                    {item.map((SO, innerIndex) => (
                      <div key={innerIndex} className="col-4 mb-4" onClick={() => this.onOrderClick(SO.id, SO.usId)}>
                        {(this.state.SoRo === 0 && SO.date_order !== undefined)? <div className="card">
                          <div className="card-body">
                            <h5 className="card-title">{SO.partner_id[1]}</h5>
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item">
                                <span className="font-weight-bold"><b>Date :</b></span>{" "}
                                {this.state.SoRo === 0
                                  ? SO.date_order
                                  : SO.invoice_date}
                              </li>
                              <li className="list-group-item">
                                <span className="font-weight-bold"><b>Total :</b></span>{" "}
                                {SO.amount_total} {SO.currency_id?.[1] || this.state?.clientCurrency?.[1] || ""}
                              </li>
                              <li className="list-group-item">
                                <span className="font-weight-bold"><b>Type :</b></span>{" "}
                                {SO.name}
                              </li>
                            </ul>
                          </div>
                        </div> : null}
                        
                      </div>
                    ))}
                  </div>
                );
              }else if (this.state.SoRo === 1 && index === 1) {
                return (
                  <div key={index} className="row mt-5" >
                    {item.map((SO, innerIndex) => (
                      <div key={innerIndex} className="col-4 mb-4" onClick={() => this.onOrderClick(SO.id, SO.usId)}>
                        {(this.state.SoRo === 1 && SO.date_order !== undefined)? <div className="card">
                          <div className="card-body">
                            <h5 className="card-title">{SO.partner_id[1]}</h5>
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item">
                                <span className="font-weight-bold"><b>Date :</b></span>{" "}
                                {this.state.SoRo === 1
                                  ? SO.date_order
                                  : SO.invoice_date}
                              </li>
                              <li className="list-group-item">
                                <span className="font-weight-bold"><b>Total :</b></span>{" "}
                                {SO.amount_total} {SO.currency_id?.[1] || this.state?.clientCurrency?.[1] || ""}
                              </li>
                              <li className="list-group-item">
                                <span className="font-weight-bold"><b>Type :</b></span>{" "}
                                {SO.name}
                              </li>
                            </ul>
                          </div>
                        </div> : null}
                        
                      </div>
                    ))}
                  </div>
                );
              }else if (this.state.SoRo === 2 && index === 5) {
                return (
                  <div key={index} className="row mt-5" >
                    {item.map((SO, innerIndex) => (
                      <div key={innerIndex} className="col-4 mb-4" onClick={() => this.onOrderClick(SO.id, SO.usId)}>
                        {(this.state.SoRo === 2 && SO.date_order !== undefined)? <div className="card">
                          <div className="card-body">
                            <h5 className="card-title">{SO.partner_id[1]}</h5>
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item">
                                <span className="font-weight-bold"><b>Date :</b></span>{" "}
                                {this.state.SoRo === 2
                                  ? SO.date_order
                                  : SO.invoice_date}
                              </li>
                              <li className="list-group-item">
                                <span className="font-weight-bold"><b>Total :</b></span>{" "}
                                {SO.amount_total} {SO.currency_id?.[1] || this.state?.clientCurrency?.[1] || ""}
                              </li>
                              <li className="list-group-item">
                                <span className="font-weight-bold"><b>Type :</b></span>{" "}
                                {SO.name}
                              </li>
                            </ul>
                          </div>
                        </div> : null}
                        
                      </div>
                    ))}
                  </div>
                );
              } else if (this.state.SoRo === 3) {
                return (
                  <div key={index} className="row mt-5">
                    {item.map((SO, innerIndex) => (
                      <div key={innerIndex} className="col-4 mb-4" onClick={() => this.onOrderClick(SO.id, SO.usId)}>
                        {this.state.SoRo === 3 &&
                        SO.invoice_date !== undefined ? (
                          <div className="card">
                            <div className="card-body">
                              <h5 className="card-title">{SO.partner_id[1]}</h5>
                              <ul className="list-group list-group-flush">
                                <li className="list-group-item">
                                  <span className="font-weight-bold">
                                  <b>Date :</b>
                                  </span>{" "}
                                  {this.state.SoRo === 3 ? SO.invoice_date : null}
                                </li>
                                <li className="list-group-item">
                                  <span className="font-weight-bold">
                                  <b>Total :</b>
                                  </span>{" "}
                                  {SO.amount_total} {SO.currency_id?.[1] || this.state?.clientCurrency?.[1] || ""}
                                </li>
                                <li className="list-group-item">
                                  <span className="font-weight-bold">
                                  <b>Type :</b>:
                                  </span>{" "}
                                  {SO.name}
                                </li>
                              </ul>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    ))}
                  </div>
                );
              }
            }
          })}
        </div>

      
      </div>
    );
  }
}
